import React from "react";
import styled from "styled-components";

const ImageBlock = styled.div `
width: 100%;
height: 100%;
background-color:#333;
position: absolute;
top: 0;
left: 0;
`;

export default ImageBlock;